/**
 * @tokenstreaming/shared — ABI constants and default parameters.
 */

export const ERC20_ABI = [
  'function name() view returns (string)',
  'function symbol() view returns (string)',
  'function decimals() view returns (uint8)',
  'function totalSupply() view returns (uint256)',
  'function balanceOf(address owner) view returns (uint256)',
  'function transfer(address to, uint256 amount) returns (bool)',
  'function approve(address spender, uint256 amount) returns (bool)',
  'function allowance(address owner, address spender) view returns (uint256)',
  'function transferFrom(address from, address to, uint256 amount) returns (bool)',
  'event Transfer(address indexed from, address indexed to, uint256 value)',
  'event Approval(address indexed owner, address indexed spender, uint256 value)',
] as const;

export const QR20_CHANNEL_ABI = [
  'function openChannel(string channelId, address resolver, address token, uint256 deposit, uint256 disputeWindowSeconds) external',
  'function closeChannel(string channelId, uint256 sequence, uint256 creatorAmount, uint256 resolverAmount, bytes jcsStateBytes, bytes creatorSig, bytes resolverSig, tuple(address recipient, uint256 bps)[] distributionRecipients, uint256 distributionSourceAmount) external',
  'function reclaimFunds(string channelId) external',
  'function getChannelIdHash(string channelId) external pure returns (bytes32)',
  'function isChannelOpen(string channelId) external view returns (bool)',
  'function channels(bytes32) external view returns (address creator, address resolver, address token, uint256 totalDeposited, uint256 disputeWindowSeconds, uint256 openedAt, uint256 sequence, bool closed)',
  'event ChannelOpened(bytes32 indexed channelIdHash, string channelId, address indexed creator, address indexed resolver, address token, uint256 deposit, uint256 disputeWindowSeconds)',
  'event ChannelClosed(bytes32 indexed channelIdHash, string channelId, uint256 sequence, uint256 creatorAmount, uint256 resolverAmount)',
  'event FundsReclaimed(bytes32 indexed channelIdHash, string channelId, address indexed reclaimer, uint256 amount)',
  'event DistributionPaid(bytes32 indexed channelIdHash, address indexed recipient, uint256 amount, string role)',
] as const;
